import {getSelectDescription} from '@/components/ContactForm/helpers';
import {ICountriesDictionary} from '@/dictionaries/utils/countries/types';
import {Country} from '@/services/countries';

type Props = {
  lang: string;
  countriesDict: ICountriesDictionary;
};

export default function useCountries({lang, countriesDict}: Props) {
  let languageCountry: Country | undefined;

  const {countries, ...rest} = getSelectDescription(lang, countriesDict);

  languageCountry = rest;

  //Uncomment when request to get countries is created in back-end
  /* countries.forEach((country) => {
      const translation = countriesDict[country.name];
      if (translation) {
        translatedCountries.push({
          ...country,
          name: translation,
        });
      }
    });

    if (lang == 'en') {
      const englishCountry = translatedCountries.find(
        (country) => country.code === 'GB',
      );
      languageCountry = englishCountry;
    } else {
      const currentLanguageCountry = translatedCountries.find(
        (country) => country.code === lang.toLocaleUpperCase(),
      );
      languageCountry = currentLanguageCountry;
    } */

  return {
    translatedCountries: countries,
    languageCountry,
  };
}
